import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';

import InventoryitemPage from 'components/inventoryitem/page/InventoryitemPage';
export default function MannageInventoryActionImpl(){

    return (
        <>
        <InventoryitemPage/>
        </>
    )
}